<div class="insights-header">
    <!-- {{'memberView.personalInsights' | translate}} -->
</div>
<div class="insights-content">
    <app-carousel *ngIf="insightsRetreived" [showDotsStepper]="true" [showFooterControls]="true" [isRTL]="isRTL" [chips]="chips">
        <ng-container *ngFor="let insight of insightsAgg">
            <ng-container *carouselItem>
                <div class="insightTitle">
                    {{ insight.insightType.text }}
                </div>               
                    <mat-accordion class="insightItem" *ngFor="let insightItem of insight.insights;"> 
                        <mat-expansion-panel >
                            <mat-expansion-panel-header [ngClass]="{'is-mobile-view': isMobileView}">
                                <mat-panel-title class="insight-short-description">
                                    <app-claro-icon-mat-icon class="claroIcon" [colorScheme]="motivationsService.getMotivationColor(insightItem.motivationId)" [lineHeight]="'1em'" [iconName]="getMotivationIconName(insightItem.motivationId)" [size]="'26px'" [fontSize]="'24px'"></app-claro-icon-mat-icon>
                                    <span class="insights_short-description-text" [ngClass]="{'is-mobile-view': isMobileView}">{{ insightItem.shortDescription }}</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <div class="insights-text">
                                {{ insightItem.longDescription }}
                            </div>
                            </mat-expansion-panel>
                    </mat-accordion>   
            </ng-container>
        </ng-container>
    </app-carousel> 
</div>